<template>
    <div class="moderate">

        <resource-list
            :title="listTitle"
            :is-loading="isLoading"
            :resources="filteredResources"
            is-editing="true"
        />

    </div>
</template>

<script>
import ResourceList from './ResourceList';
import axios from 'axios';
import _ from 'lodash';
import BoxResourceTransformer from '../BoxResourceTransformer';

/*
const mockResults = [
    {
        id: 'abc123',
        title: 'How Fortnite Captured Teens\' Hearts and Minds',
        sourceUrl: 'http://thenewyorker.com',
        sourceName: 'The New Yorker',
        sourceFavicon: '/images/www.newyorker.com.ico',
        publishedAt: '2018-05-21',
        previewImage: 'http://via.placeholder.com/64x64',
        previewHtml: '<p>The craze for the third-person shooter game has elements of Beatlemania, the opioid crisis, and eating Tide Pods.</p>',
        attribution: {
            name: 'Bart Johnston',
            avatar: '/images/bart.jpg',
            clippedAt: '2018-05-21T18:00:00Z',
            slackChannel: '#ar-culturewindow',
            comment: '<p>In case you don’t have teen/tweenage kids and don’t know about it, Fortnite is kind of a big deal, and seems to have tapped into something different than other popular games (like LoL).</p>'
        },
        tags: ['gen Z', 'gaming', 'esports']
    },
    {
        id: 'def456',
        title: 'How Fortnite Captured Teens\' Hearts and Minds',
        sourceUrl: 'http://thenewyorker.com',
        sourceName: 'The New Yorker',
        sourceFavicon: '/images/www.newyorker.com.ico',
        publishedAt: '2018-05-21',
        previewImage: 'http://via.placeholder.com/64x64',
        previewHtml: '<p>The craze for the third-person shooter game has elements of Beatlemania, the opioid crisis, and eating Tide Pods.</p>',
        attribution: {
            name: 'Bart Johnston',
            avatar: '/images/bart.jpg',
            clippedAt: '2018-05-21T18:00:00Z',
            slackChannel: '#ar-culturewindow',
            comment: '<p>In case you don’t have teen/tweenage kids and don’t know about it, Fortnite is kind of a big deal, and seems to have tapped into something different than other popular games (like LoL).</p>'
        },
        tags: ['gen Z', 'gaming', 'esports']
    }
];
*/

let queryCache = {};

export default {
    data() {
        return {
            isLoading: false,
            listTitle: 'Pending Moderation',
            resources: []
        };
    },
    components: {
        'resource-list': ResourceList
    },
    created() {
        this.getPendingResources();
    },
    methods: {

        getPendingResources(searchParams) {
            this.isLoading = true;
            axios.get('/moderate?approved=0')
            .then(response => {
                this.showResults(response.data.resources);
            });
        },

        showResults(files) {
            this.isLoading = false;
            this.resources = _.map(files, BoxResourceTransformer);;
        }
    },
    computed: {
        filteredResources() {
          console.log(this.resources);
            return this.resources;
            return this.resources.filter(resource => resource.approved !== 1);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LibraryModerate.vue